import React, { FC } from 'react'
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts'
import styled from 'styled-components'

interface IDoubleBarChartComponentProps {
  data: {
    name: string
    value1: number
    value2: number
    fill1: string
    fill2: string
  }[]
}

// Estilizando a legenda extra
const CustomLegendContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  gap: 20px;
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
`

const ColorBox = styled.span<{ color: string }>`
  width: 12px;
  height: 12px;
  display: inline-block;
  background-color: ${(props) => props.color};
  border-radius: 2px;
`

const DoubleBarChartComponent: FC<IDoubleBarChartComponentProps> = ({ data }) => {
  // Calcula o total para obter a porcentagem
  const total1 = data.reduce((sum, item) => sum + item.value1, 0)
  const total2 = data.reduce((sum, item) => sum + item.value2, 0)

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const { name } = payload[0].payload
      const value1 = payload[0].value
      const value2 = payload[1]?.value || 0
      const percentage1 = ((value1 / total1) * 100).toFixed(2) + '%'
      const percentage2 = ((value2 / total2) * 100).toFixed(2) + '%'

      return (
        <div style={{ background: 'white', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}>
          <p><strong>{name}</strong></p>
          <p>Total: {value1} ({percentage1})</p>
          <p>Atrasados: {value2} ({percentage2})</p>
        </div>
      )
    }
    return null
  }

  return (
    <div>
      {/* Legenda Extra Acima do Gráfico */}
      <CustomLegendContainer>
        <strong>Destaque:</strong>
        <LegendItem>
          <ColorBox color={data[0]?.fill1 || '#8884d8'} />
          Total: {total1}
        </LegendItem>
        <LegendItem>
          <ColorBox color={data[0]?.fill2 || '#82ca9d'} />
          Atrasados: {total2}
        </LegendItem>
      </CustomLegendContainer>

      {/* Gráfico */}
      <ResponsiveContainer width="100%" height={400}>
        <RechartsBarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="value1" name="Valor 1">
            {data.map((entry, index) => (
              <Cell key={`cell1-${index}`} fill={entry.fill1} />
            ))}
          </Bar>
          <Bar dataKey="value2" name="Valor 2">
            {data.map((entry, index) => (
              <Cell key={`cell2-${index}`} fill={entry.fill2} />
            ))}
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  )
}

export { DoubleBarChartComponent }
